// Links in CMS bodies (pages, blog posts, SMWW News) typed with the live site's domain. The bodies
// come from the live site, where such a link stays on the site; here it would leave this one.

import { configData } from '../config';

// A link in a body typed with the live site's domain (sportsmanagementworldwide.com with www., team.
// or none, or smww.com, which sends visitors there; http or https): the href= with its quote, the
// domain, then the path, if any
const LIVE_SITE_LINK = /(\shref=["'])https?:\/\/((?:www\.|team\.)?sportsmanagementworldwide\.com|(?:www\.)?smww\.com)(\/[^"'?#]*)?(?=["'?#])/gi;
// Paths of files, which only the live site has: Drupal's files folder (/sites/...) and anything
// whose name has an extension (.pdf, .jpg, .php ...), except the old .asp pages, which the live
// site sends on to its pages (pageRedirects.js)
const isLiveFile = (path) => /^\/sites\/|\.(?!aspx?$)\w+$/i.test(path);
// A live link's address on this site, also for pages not on this site yet (staff and mentor
// profiles, the Concordia and Fort Hays sites, the alumni form, ...): the same path, but a
// course's pay link (smww_pay/<code>) goes to the course on the pay page (smww_pay#<code>), as
// the live site sends it. A link to the team site (team.sportsmanagementworldwide.com, the live
// deployment of this app: the pay page, the cart, sign-in) goes to this setup's team site,
// RSMWW_TEAM_URL, as the header's Login link and cart icon do; the others stay on this site
const sitePath = (domain, path) =>
    (/^team\./i.test(domain) ? configData.RSMWW_TEAM_URL || '' : '')
    + (path || '/').replace(/^\/smww_pay\/([^/]+)\/?$/i, '/smww_pay#$1');

// A body with its live-site links (LIVE_SITE_LINK) kept on the current site, query string and
// all (an old address goes on to its page through pageRedirects.js); links to files still go to
// the live site
export const keepLiveLinksOnSite = (html) =>
    String(html || '').replace(LIVE_SITE_LINK, (link, attribute, domain, path = '') => (isLiveFile(path) ? link : attribute + sitePath(domain, path)));

// A single address typed with the live site's domain (LIVE_SITE_LINK), such as the promo bar's
// button link, which comes from the live site's settings: the path on the current site (on the
// team site for a team. address), query string and all; a file's address, or one on another
// site, as it is
const LIVE_SITE_ADDRESS = /^https?:\/\/((?:www\.|team\.)?sportsmanagementworldwide\.com|(?:www\.)?smww\.com)(\/[^?#]*)?(?=[?#]|$)/i;
export const keepLiveAddressOnSite = (address) =>
    address ? String(address).trim().replace(LIVE_SITE_ADDRESS, (link, domain, path = '') => (isLiveFile(path) ? link : sitePath(domain, path))) : address;
